// extracted by mini-css-extract-plugin
module.exports = {"tabItem":"UX-jYp","tabButton":"gVFBRH","tabButtonNoWrap":"SM-uj4"};